export default __webpack_public_path__ + "static/curam-icon-512-2c285d5a65cb0c16b03abb34d1bd59c8.png";